module.exports = __webpack_public_path__ + "assets/cff86944fcf4950662168e5b6447b959.mp3";